// extracted by mini-css-extract-plugin
export default {"base":"HomeTorneos_base__u-XPN","cuadroTorneos":"HomeTorneos_cuadroTorneos__JLHH9","contenedorCuadros":"HomeTorneos_contenedorCuadros__xQxh1"};